<template>
  <VContainer grid-list-sm>
    <VLayout row>
      <VFlex order-xs5 sm12 md12>
        <LoadingDialog ref="LoadingDialog" />
        <VCard color="primary" dark>
          <VCardTitle class="title">Configurações</VCardTitle>
          <VContainer>
            <VCardText>
              <VLayout />
            </VCardText>
          </VContainer>
        </VCard>
      </VFlex>
    </VLayout>
    <VForm ref="unidade">
      <VLayout row wrap>
        <VFlex order-xs5 sm12 md12>
          <VCard>
            <VCardTitle class="title">Cores</VCardTitle>
            <VCardText>
              <VLayout row wrap class="pa-2" justify-space-around>
                <VFlex xs12 sm12 md12>
                  <VExpansionPanel expand v-model="visibilidadePaineis">
                    <VExpansionPanelContent>
                      <template v-slot:header>
                        <div class="head">Função</div>
                      </template>
                      <VCard>
                        <VFlex xs12 sm12 md12>
                          <table
                            v-if="funcaoCoresItems.length > 0"
                            class="v-table theme--light"
                          >
                            <thead class="thead-dark">
                              <tr>
                                <th
                                  v-for="(cab, index) in headersFuncoes"
                                  :key="index"
                                >
                                  {{ cab.text }}
                                </th>
                              </tr>
                            </thead>
                            <draggable v-model="funcaoCoresItems" tag="tbody">
                              <tr
                                v-for="(reg, index) in funcaoCoresItems"
                                :key="reg.funcao.id"
                              >
                                <td>
                                  <VIcon class="handle">drag_indicator</VIcon>
                                </td>
                                <td>{{ reg.funcao.nome }}</td>
                                <td class="text-xs-left">
                                  <input type="color" v-model="reg.cor.fundo" />
                                </td>
                                <td class="text-xs-left">
                                  <input type="color" v-model="reg.cor.texto" />
                                </td>
                                <td class="text-xs-center">
                                  <VCard
                                    :color="reg.cor.fundo.concat('52')"
                                    class="item pa-0"
                                  >
                                    <VCardText
                                      :style="{ color: reg.cor.texto }"
                                    >
                                      {{ reg.funcao.nome }}
                                    </VCardText>
                                  </VCard>
                                </td>
                                <td class="text-xs-left">
                                  <VTooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <VBtn
                                        icon
                                        small
                                        flat
                                        v-on="on"
                                        color="primary"
                                        @click="restaurarPadraoCorFuncao(index)"
                                      >
                                        <VIcon>settings_backup_restore</VIcon>
                                      </VBtn>
                                    </template>
                                    <span>Restaurar cor padrão</span>
                                  </VTooltip>
                                </td>
                              </tr>
                            </draggable>
                          </table>
                        </VFlex>
                        <VFlex xs12 sm3 md3>
                          <VBtn block @click="restaurarPadroesFuncao"
                            >Restaurar padrão</VBtn
                          >
                        </VFlex>
                      </VCard>
                    </VExpansionPanelContent>
                    <VExpansionPanelContent>
                      <template v-slot:header>
                        <div class="head">Situação</div>
                      </template>
                      <VCard>
                        <VDataTable
                          :items="situacaoCoresItems"
                          :headers="headers"
                          class="elevation-1"
                          hide-actions
                        >
                          <template v-slot:items="props">
                            <td>{{ props.item.nome }}</td>
                            <td class="text-xs-left">
                              <input
                                type="color"
                                v-model="props.item.cores.fundo"
                              />
                            </td>
                            <td class="text-xs-left">
                              <input
                                type="color"
                                v-model="props.item.cores.texto"
                              />
                            </td>
                            <td class="text-xs-center">
                              <VCard
                                :color="props.item.cores.fundo"
                                class="item pa-0"
                              >
                                <VCardText
                                  :style="{ color: props.item.cores.texto }"
                                >
                                  {{ props.item.nome }}
                                </VCardText>
                              </VCard>
                            </td>
                            <td class="text-xs-left">
                              <VTooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <VBtn
                                    icon
                                    small
                                    flat
                                    v-on="on"
                                    color="primary"
                                    @click="
                                      restaurarPadraoCor(
                                        props.index,
                                        props.item.nome
                                      )
                                    "
                                  >
                                    <VIcon>settings_backup_restore</VIcon>
                                  </VBtn>
                                </template>
                                <span>Restaurar cor padrão</span>
                              </VTooltip>
                            </td>
                          </template>
                        </VDataTable>
                        <VFlex xs12 sm3 md3>
                          <VBtn block @click="restaurarPadroes"
                            >Restaurar padrão</VBtn
                          >
                        </VFlex>
                      </VCard>
                    </VExpansionPanelContent>
                  </VExpansionPanel>
                </VFlex>
                <VFlex> </VFlex>
              </VLayout>
            </VCardText>
          </VCard>
        </VFlex>
      </VLayout>

      <VLayout row wrap>
        <VFlex order-xs5 sm12 md12>
          <VCard>
            <VCardTitle class="title"
              >Intervalo de tempo entre as linhas da agenda</VCardTitle
            >
            <VCardText>
              <VLayout class="pa-3" justify-space-between>
                <VFlex xs5 sm5 md5>
                  <VSlider
                    v-model="configuracoesAgenda.minutosDuracaoLinha"
                    color="primary"
                    thumb-label="always"
                    persistent-hint
                    min="5"
                    max="60"
                    step="5"
                    hint="Cada linha da agenda equivale a quantos minutos?"
                    readonly
                  >
                    <template v-slot:prepend>
                      <VIcon
                        color="primary"
                        @click="subtraiMinutos"
                        v-if="
                          $store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
                          $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
                        "
                      >
                        indeterminate_check_box
                      </VIcon>
                    </template>
                    <template v-slot:append>
                      <VIcon
                        color="primary"
                        @click="adicionaMinutos"
                        v-if="
                          $store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
                          $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
                        "
                      >
                        add_box
                      </VIcon>
                    </template>
                  </VSlider>
                </VFlex>
              </VLayout>
            </VCardText>
          </VCard>
        </VFlex>
      </VLayout>

      <VLayout row wrap>
        <VFlex order-xs5 sm12 md12>
          <VCard>
            <VCardTitle class="title"
              >Horário de Início e Horário de Término</VCardTitle
            >
            <VCardText>
              <VLayout row wrap class="pa-2" justify-space-around>
                <VFlex xs12 sm6 md5>
                  <VTextField
                    label="Horário de Início"
                    prepend-icon="alarm"
                    type="time"
                    :rules="[rules.obrigatorio()]"
                    v-model="configuracoesAgenda.horarioInicio"
                    :readonly="
                      !(
                        $store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
                        $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
                      )
                    "
                  ></VTextField>
                </VFlex>
                <VFlex xs12 sm6 md5>
                  <VTextField
                    label="Horário de Término"
                    prepend-icon="alarm"
                    type="time"
                    :rules="[rules.obrigatorio()]"
                    v-model="configuracoesAgenda.horarioTermino"
                    :readonly="
                      !(
                        $store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
                        $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
                      )
                    "
                  ></VTextField>
                </VFlex>
              </VLayout>
            </VCardText>
          </VCard>
        </VFlex>
      </VLayout>

      <VLayout row wrap>
        <VFlex order-xs5 sm12 md12>
          <VCard>
            <VCardTitle class="title">Tolerância para agendamentos</VCardTitle>
            <VCardText>
              <VLayout row wrap class="pa-2" style="margin-left: 2%">
                <VFlex xs12 sm6 md5>
                  <VTextField
                    label="Tolerância"
                    type="time"
                    v-model="configuracoesAgenda.toleranciaAgendamento"
                    :readonly="
                      !(
                        $store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
                        $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
                      )
                    "
                  ></VTextField>
                </VFlex>
              </VLayout>
            </VCardText>
          </VCard>
        </VFlex>
      </VLayout>

      <VLayout row wrap>
        <VFlex order-xs5 sm12 md12>
          <VCard row wrap class="pa-2" justify-space-around>
            <VCardTitle class="title"
              >Configuração da Tabela de Preço</VCardTitle
            >
            <VLayout row wrap class="pa-2" style="margin-left: 2%">
              <VFlex xs12 sm6 md5>
                <VAutocomplete
                  v-model="selectedTabelaPreco"
                  label="Tabela de Preço"
                  :items="tabelaPreco"
                  item-value="id"
                  item-text="nome"
                  color="primary"
                  :readonly="!($store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor && $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais)"
                />
              </VFlex>
            </VLayout>
          </VCard>
        </VFlex>
      </VLayout>
      <VLayout row wrap>
        <VFlex>
          <VCard justify-space-around class="pa-2">
            <VCardText />
              <VCheckbox
                justify-space-around class="pa-2"
                color="primary"
                label="Permitir agendamentos com reserva de Equipamentos"
                v-model="configuracoesAgenda.permiteReservarEquipamentos"
                :disabled="!$store.state.parametros.configuracoesUsuario.permissaoEquipamentos"
              />
              <VCheckbox
                justify-space-around class="pa-2"
                color="primary"
                label="Permitir múltiplos agendamentos para um colaborador no mesmo dia e horário"
                v-model="configuracoesAgenda.multiplosAgendamentos"
                :disabled="!($store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor && $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais)"
              />
              <VCheckbox
                justify-space-around class="pa-2"
                color="primary"
                label="Permitir múltiplos agendamentos em um espaço no mesmo dia e horário"
                v-model="configuracoesAgenda.multiplosAgendamentosMesmoEspaco"
                :disabled="!($store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor && $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais)"
              />
              <VCheckbox
                justify-space-around class="pa-2"
                color="primary"
                label="Permitir o envio de notificações de agendamento via WhatsApp"
                v-model="configuracoesAgenda.permissaoEnvioNotificacaoWhatsApp"
                :disabled="!($store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor && $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais)"
              />
              <VCheckbox
                justify-space-around
                class="pa-2"
                color="primary"
                label="Execução de Serviço com Confirmação Biometria"
                v-model="configuracoesAgenda.permissaoExecucaoServicoConfirmacaoBiometria"
              />
              <VCheckbox
                justify-space-around class="pa-2"
                color="primary"
                label="Atendimento com Prontuário Eletrônico"
                v-model="configuracoesAgenda.atendimentoProntuario"
              />
          </VCard>
        </VFlex>
      </VLayout>
      <VLayout row wrap>
        <VFlex>
          <VCard>
            <VCardTitle class="title"
              >Configuração da mensagem de compartilhamento
            </VCardTitle>
            <VCardText>
              <VLayout wrap class="pa-2">
                <VLabel for="params-input">Tags</VLabel>
              </VLayout>
              <VChip
                v-for="(param, index) in params"
                :key="index"
                @click="addParam(param)"
              >
                <span style="cursor: pointer">{{ param }}</span>
              </VChip>
              <br />
              <br />
              <VTextarea
                id="mensagemText"
                :maxlength="1000"
                label="Mensagem"
                class="pa-2"
                type="text-area"
                v-model="
                  configuracoesAgenda.mensagemCompartilhamentoStatusAgenda
                "
              ></VTextarea>
              <span class="pa-2" style="color: grey; font-size: smaller"
                >Limite de caracteres</span
              >
              <div
                style="font-size: 12px"
                class="input-group-addon pa-2"
                v-text="
                  1000 -
                  (configuracoesAgenda.mensagemCompartilhamentoStatusAgenda !=
                  null
                    ? configuracoesAgenda.mensagemCompartilhamentoStatusAgenda
                        .length
                    : 0)
                "
                :class="
                  1000 -
                    (configuracoesAgenda.mensagemCompartilhamentoStatusAgenda !=
                    null
                      ? configuracoesAgenda.mensagemCompartilhamentoStatusAgenda
                          .length
                      : 0) <
                  10
                    ? 'red'
                    : 'grey'
                "
              ></div>
            </VCardText>
          </VCard>
        </VFlex>
      </VLayout>
      <VLayout row wrap>
        <VFlex>
          <VCard>
            <VCardText />
            <VCardActions>
              <VLayout class="pa-2" justify-space-around>
                <BotaoCancelar />
                <VTooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      block
                      class="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="salvarConfiguracao"
                      :disabled="
                        !(
                          $store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
                          $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
                        )
                      "
                      >Salvar</VBtn
                    >
                  </template>
                  <span
                    >{{
                      $store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
                      $store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
                        ? "Clique para salvar!"
                        : "Parâmetro Diversos → Permissões Gerais do Grupo Diversos precisa estar ativado!"
                    }}
                  </span>
                </VTooltip>
              </VLayout>
            </VCardActions>
          </VCard>
        </VFlex>
      </VLayout>
    </VForm>
  </VContainer>
</template>

<script>
import ApiService from "@/common/api.service";
import alerts from "@/common/alerts";
import coresPadrao from "@/common/situacoes.cores";
import * as mutations from "@/plugins/mutations.nomes";
import LoadingDialog from "@/components/Dialog/Loading";
import forms from "../common/forms";
import BotaoCancelar from "@/components/Botoes/BotaoCancelar";
import draggable from "vuedraggable";
import situacoes from "@/common/situacoes";

export default {
  name: "Configuracao",
  components: { LoadingDialog, BotaoCancelar, draggable },
  data() {
    return {
      headers: [
        {
          text: "Situação",
          align: "left",
          sortable: false,
        },
        {
          text: "Cor fundo",
          align: "left",
          sortable: false,
        },
        {
          text: "Cor texto",
          align: "left",
          sortable: false,
        },
        {
          text: "Visualização",
          align: "left",
          sortable: false,
        },
        {
          text: "Ações",
          align: "left",
          sortable: false,
        },
      ],
      headersFuncoes: [
        {
          text: "",
          align: "left",
          sortable: false,
        },
        {
          text: "Função",
          align: "left",
          sortable: false,
        },
        {
          text: "Cor fundo",
          align: "left",
          sortable: false,
        },
        {
          text: "Cor texto",
          align: "left",
          sortable: false,
        },
        {
          text: "Visualização",
          align: "left",
          sortable: false,
        },
        {
          text: "Ações",
          align: "left",
          sortable: false,
        },
      ],
      situacaoCoresItems: [],
      visibilidadePaineis: [false, false],
      funcoesProfissional: [],
      configuracoesAgenda: {
        minutosDuracaoLinha: null,
        horarioInicio: null,
        horarioTermino: null,
        toleranciaAgendamento: "00:00",
        multiplosAgendamentos: null,
        multiplosAgendamentosMesmoEspaco: null,
        permissaoEnvioNotificacaoWhatsApp: null,
        mensagemCompartilhamentoStatusAgenda: null,
        permiteReservarEquipamentos: null,
        permissaoExecucaoServicoConfirmacaoBiometria: null,
        atendimentoProntuario: null,
      },
      rules: forms.rules,
      text: "",
      params: [
        "{nomeCliente}",
        "{servicos}",
        "{statusServico}",
        "{telefoneEmpresa}",
        "{emailEmpresa}",
        "{empresa}",
        "{data}",
        "{hora}",
      ],
      selectedParam: null,
      selectedTabelaPreco: 1,
      tabelaPreco: [
        {
          id: 1,
          nome: "Tabela padrão",
        },
      ],
    };
  },
  async activated() {
    this.visibilidadePaineis = [false, false];

    let parametros = {};
    var coresAgenda = this.coresAgenda;

    try {
      [this.funcoesProfissional, parametros, this.tabelaPreco] = (
        await this.$refs.LoadingDialog.aguardarPromises([
          ApiService.get("profissionais/funcoes"),
          ApiService.get("parametros"),
          ApiService.get(`configuracoes/buscarTabelaPreco`),
        ])
      ).map((r) => r.data);

      if (parametros.configuracoes != null) {
        let situacaoCores = Object.keys(parametros.configuracoes.cores);
        let parametrosSituacaoCores = this.sincNovasSituacoes(
          situacaoCores,
          parametros.configuracoes.cores
        );
        coresAgenda = parametrosSituacaoCores;

        this.configuracoesAgenda.minutosDuracaoLinha =
          parametros.configuracoes.minutosDuracaoLinha || 30;
        this.configuracoesAgenda.horarioInicio =
          parametros.configuracoes.horarioInicio;
        this.configuracoesAgenda.horarioTermino =
          parametros.configuracoes.horarioTermino;
        this.configuracoesAgenda.toleranciaAgendamento =
          parametros.configuracoes.toleranciaAgendamento;
      }

      if (parametros.configuracoesServicos != null) {
        this.configuracoesAgenda.multiplosAgendamentos = parametros.configuracoesServicos.multiplosAgendamentos || false;
        this.configuracoesAgenda.multiplosAgendamentosMesmoEspaco = parametros.configuracoesServicos.multiplosAgendamentosMesmoEspaco || false;
        this.configuracoesAgenda.permissaoEnvioNotificacaoWhatsApp = parametros.configuracoesServicos.permissaoEnvioNotificacaoWhatsApp || false;
        this.configuracoesAgenda.mensagemCompartilhamentoStatusAgenda = parametros.configuracoesServicos.mensagemCompartilhamentoStatusAgenda || "";
        this.selectedTabelaPreco = parametros.configuracoesServicos.tabelaPrecoSelecionada || 1;
        this.configuracoesAgenda.permiteReservarEquipamentos = parametros.configuracoesServicos.permiteReservarEquipamentos;
        this.configuracoesAgenda.permissaoExecucaoServicoConfirmacaoBiometria = parametros.configuracoesServicos.execucaoServicoComConfirmacaoBiometrica;
        this.configuracoesAgenda.atendimentoProntuario = parametros.configuracoesServicos.atendimentoProntuario || false;
      }

      this.situacaoCoresItems = Object.keys(coresAgenda).map((k) => ({
        nome: k,
        cores: Object.assign({}, coresAgenda[k]),
      }));
    } catch (e) {
      await alerts.exibirErro(
        "Não foi possível recuperar as configurações da agenda",
        e
      );
    }

    this.sincronizarFuncoes(parametros.configuracoes);
  },
  watch: {},
  computed: {
    coresAgenda() {
      return this.$store.state.coresAgenda;
    },
    funcaoCoresItems: {
      get() {
        return this.$store.state.funcaoCoresItems;
      },
      set(value) {
        this.$store.commit(mutations.ATUALIZAR_CONFIGURACAO_FUNCAO, value);
      },
    },
  },
  methods: {
    sincNovasSituacoes(situacaoCores, parametrosSituacaoCores) {
      for (const situacao of situacoes) {
        var novaSituacao = true;

        for (const item of situacaoCores) {
          if (situacao.nome === item) {
            novaSituacao = false;
            break;
          }
        }

        if (novaSituacao)
          Object.assign(parametrosSituacaoCores, {
            [situacao.nome]: this.coresAgenda[situacao.nome],
          });
      }
      return parametrosSituacaoCores;
    },
    addParam(selectedParam) {
      if (selectedParam !== null) {
        let input = document.getElementById("mensagemText");
        let start = input.selectionStart;
        let end = input.selectionEnd;
        let value = input.value;
        let newValue =
          value.substring(0, start) +
          selectedParam +
          value.substring(end, value.length);
        this.configuracoesAgenda.mensagemCompartilhamentoStatusAgenda =
          newValue;
        input.selectionStart = start + selectedParam.length;
        input.selectionEnd = start + selectedParam.length;
        input.focus();
      }
    },

    subtraiMinutos() {
      this.configuracoesAgenda.minutosDuracaoLinha =
        this.configuracoesAgenda.minutosDuracaoLinha - 5 || 0;
    },
    adicionaMinutos() {
      this.configuracoesAgenda.minutosDuracaoLinha =
        this.configuracoesAgenda.minutosDuracaoLinha + 5 || 60;
    },
    criarNovoItemFuncao(funcao) {
      return {
        funcao: funcao,
        cor: this.carregarCorPadraoFuncao(),
      };
    },
    carregarCorPadraoFuncao() {
      return {
        fundo: "#ffffff",
        texto: "#000000",
      };
    },

    atualizarOrdenacaoListaFuncoes() {
      var funcoesOrdenadas = [];
      for (var i = 0; i < this.funcaoCoresItems.length; i++) {
        var funcao = this.funcaoCoresItems[i].funcao;
        funcoesOrdenadas[i] = funcao;
      }
      this.$store.commit(mutations.ATUALIZAR_LISTA_FUNCOES, funcoesOrdenadas);
    },
    async sincronizarFuncoes(configuracoes) {
      this.funcaoCoresItems =
        configuracoes != null
          ? configuracoes.funcaoCoresItems
          : this.funcaoCoresItems;
      var existeConfiguracaoFuncoes =
        this.funcaoCoresItems != null && this.funcaoCoresItems.length > 0;

      if (!existeConfiguracaoFuncoes) {
        this.criarNovaConfiguracaoFuncoes();
      } else {
        this.sincNovasFuncoes();
        this.sincFuncoesExcluidas();
      }

      if (
        !(
          this.$store.state.parametros.configuracoesUsuario.permissaoUsuarioSupervisor &&
          this.$store.state.parametros.configuracoesUsuario.permissaoParametrosGlobais
        )
      ) {
        await alerts.exibirInformacao("Atenção",
          "Para a edição das configurações é necessário ativar a permissão de usuário 'Parâmetros Globais' presente no grupo 'Diversos' e ser um usuário Supervisor!"
        );
      }
    },

    criarNovaConfiguracaoFuncoes() {
      this.funcaoCoresItems = Object.keys(this.funcoesProfissional).map(
        (k) => ({
          funcao: this.funcoesProfissional[k],
          cor: Object.assign({}, this.carregarCorPadraoFuncao()),
        })
      );
    },
    sincNovasFuncoes() {
      for (const funcao of this.funcoesProfissional) {
        var novaFuncao = true;

        for (const item of this.funcaoCoresItems) {
          if (funcao.nome === item.funcao.nome) {
            novaFuncao = false;
            break;
          }
        }

        if (novaFuncao) {
          var novoItemFuncaoCores = this.criarNovoItemFuncao(funcao);
          this.funcaoCoresItems.push(novoItemFuncaoCores);
        }
      }
    },
    sincFuncoesExcluidas() {
      for (const item of this.funcaoCoresItems) {
        var funcaoExcluida = true;

        for (const funcao of this.funcoesProfissional) {
          if (item.funcao.nome === funcao.nome) {
            funcaoExcluida = false;
            break;
          }
        }

        if (funcaoExcluida) {
          this.funcaoCoresItems.splice(this.funcaoCoresItems.indexOf(item), 1);
        }
      }
    },
    restaurarPadroes() {
      for (let situacao of this.situacaoCoresItems) {
        situacao.cores = Object.assign({}, coresPadrao[situacao.nome]);
      }
    },
    restaurarPadraoCor(indice, situacao) {
      this.situacaoCoresItems[indice].cores = Object.assign(
        {},
        coresPadrao[situacao]
      );
    },
    restaurarPadraoCorFuncao(indice) {
      this.funcaoCoresItems[indice].cor = this.carregarCorPadraoFuncao();
    },
    restaurarPadroesFuncao() {
      for (var index in this.funcaoCoresItems) {
        this.restaurarPadraoCorFuncao(index);
      }
    },
    formatarItens(itens) {
      let itensFormatados = {};
      for (let item of itens) {
        itensFormatados[item.nome] = {
          fundo: item.cores.fundo,
          texto: item.cores.texto,
        };
      }
      return itensFormatados;
    },
    async salvarConfiguracao() {
      var regex = new RegExp(":", "g");
      if (this.$refs.unidade.validate()) {
        if (
          parseInt(
            this.configuracoesAgenda.horarioInicio.replace(regex, ""),
            10
          ) >
          parseInt(
            this.configuracoesAgenda.horarioTermino.replace(regex, ""),
            10
          )
        ) {
          await alerts.exibirErro(
            "Não foi possível salvar as configurações",
            "Horário de início não pode ser maior ou igual ao horário de término!"
          );
          return;
        }

        if (!(await alerts.pedirConfirmacao("Salvar configurações?", "")))
          return;

        const configuracao = {
          configuracao: {
            cores: this.formatarItens(this.situacaoCoresItems),
            funcaoCoresItems: this.funcaoCoresItems,
            horarioInicio: this.configuracoesAgenda.horarioInicio,
            horarioTermino: this.configuracoesAgenda.horarioTermino,
            toleranciaAgendamento: this.configuracoesAgenda
              .toleranciaAgendamento
              ? this.configuracoesAgenda.toleranciaAgendamento
              : "00:00",
            minutosDuracaoLinha: this.configuracoesAgenda.minutosDuracaoLinha,
            multiplosAgendamentos:
              this.configuracoesAgenda.multiplosAgendamentos,
            multiplosAgendamentosMesmoEspaco:
              this.configuracoesAgenda.multiplosAgendamentosMesmoEspaco,
            permissaoEnvioNotificacaoWhatsApp:
              this.configuracoesAgenda.permissaoEnvioNotificacaoWhatsApp,
            mensagemCompartilhamentoStatusAgenda:
              this.configuracoesAgenda.mensagemCompartilhamentoStatusAgenda,
            tabelaPrecoSelecionada: this.selectedTabelaPreco,
            permiteReservarEquipamentos: this.configuracoesAgenda.permiteReservarEquipamentos,
            execucaoServicoComConfirmacaoBiometrica: this.configuracoesAgenda.permissaoExecucaoServicoConfirmacaoBiometria,
            atendimentoProntuario: this.configuracoesAgenda.atendimentoProntuario,
          },
        };

        try {
          await this.$refs.LoadingDialog.aguardarPromises([
            ApiService.put("configuracoes", configuracao),
          ]);
          this.$store.commit(
            mutations.ATUALIZAR_CONFIGURACAO,
            Object.assign({}, configuracao.configuracao)
          );
          await this.atualizarOrdenacaoListaFuncoes();
          await this.$router.push({ name: "Agenda" });
          document.location.reload(true);
        } catch (e) {
          await alerts.exibirErro(
            "Não foi possível salvar as configurações",
            e
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.configuracoes {
  font-size: 1.4rem;
}

.head {
  text-align: left;
}

.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}

.opacity {
  opacity: 0.4;
}

.red {
  background-color: white !important;
  color: red;
}
.grey {
  background-color: white !important;
  color: grey;
}
</style>
